import http from "./config/http-configs";

export const getAppId = () => {
    return http.get('/mobile/wx/official/list/appid')
}

export const getOpenId = (code, state) => {
    return http.get(`/mobile/wx/official/list/openid?code=${code}&state=${state}`)
}
